import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class IconBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            iconbox: [],
            loading: true,
            error: null
        }
    }

    componentDidMount() {
        this.fetchIconBoxData();
    }

    fetchIconBoxData = async () => {
        try {
            this.setState({ loading: true, error: null });

            const baseUrl = process.env.REACT_APP_API_URL || 'http://localhost:3000';
            const apiUrl = `${baseUrl}/api/ourFeature`;

            const response = await fetch(apiUrl);
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const result = await response.json();

            
            // Check if the response has the expected structure
            if (result.success && Array.isArray(result.data)) {
                this.setState({
                    iconbox: result.data,
                    loading: false
                });
            } else {
                throw new Error('Invalid data format from API');
            }
            
        } catch (error) {
            console.error('Error fetching iconbox data:', error);
            this.setState({
                loading: false,
                error: error.message
            });
        }
    }

    render() {
        const { iconbox, loading, error } = this.state;

        if (loading) {
            return (
                <div className="row">
                    <div className="col-12 text-center">
                        <div className="loading-spinner">Loading...</div>
                    </div>
                </div>
            );
        }

        if (error) {
            return (
                <div className="row">
                    <div className="col-12 text-center">
                        <div className="error-message">
                            Error loading content: {error}
                            <button onClick={this.fetchIconBoxData} className="retry-btn">
                                Retry
                            </button>
                        </div>
                    </div>
                </div>
            );
        }

        if (!iconbox || iconbox.length === 0) {
            return (
                <div className="row">
                    <div className="col-12 text-center">
                        <div className="no-data">No features available</div>
                    </div>
                </div>
            );
        }

        return (
            <div className="row">
                {iconbox.map(data => (
                    <div className="col-md-4" key={data._id || data.id}>
                        <div className="themesflat-spacer clearfix" data-desktop={0} data-mobile={0} data-smobile={35} />
                        <div className="themesflat-content-box clearfix" data-margin="0 5px 0 5px" data-mobilemargin="0 0 0 0">
                            <div className="themesflat-icon-box icon-top align-center has-width w95 circle light-bg accent-color style-1 clearfix">
                                <div className="icon-wrap">
                                    <i className={data.icon} />
                                </div>
                                <div className="text-wrap">
                                    <h5 className="heading">
                                        <Link to="#">{data.title}</Link>
                                    </h5>
                                    <div className="sep clearfix" />
                                    <p className="sub-heading">{data.text}</p>
                                </div>
                            </div>
                        </div>                                       
                    </div>  
                ))}                    
            </div>
        );
    }
}

export default IconBox;